export default __webpack_public_path__ + "static/media/pay.b0c4193f.png";